import { render } from "./BalancerPage.vue?vue&type=template&id=5f5fbadd&scoped=true"
import script from "./BalancerPage.vue?vue&type=script&lang=js"
export * from "./BalancerPage.vue?vue&type=script&lang=js"

import "./BalancerPage.vue?vue&type=style&index=0&id=5f5fbadd&scoped=true&lang=css"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5fbadd"]])

export default __exports__